import dayjs from "dayjs";

import { colorsPalettes } from "@similarweb/styles";

import { swSettings } from "app/common/services/swSettings";
import type { ITooltipsGraphConfig } from "pro-features/components/Chart/src/configs/tooltip/graphBellTooltip/graphBellTooltipContainerConfig";

import { dateToUTC } from "../components/helpers";

export enum ETooltips {
    Session_Tracking_Start_Date,
    Unique_Install_Start_Date,
    Store_Policy_Change_Date,
    Similar_Algorithm_Change_Date,
    WEEKLY_DATA_AVAILABLE,
}

const uniqueInstallStartTrackingDate = "2020-10-01";

let tooltipConfigsCache: Map<ETooltips, ITooltipsGraphConfig> | undefined;

export const getTooltipConfigs = (): Map<ETooltips, ITooltipsGraphConfig> => {
    if (!tooltipConfigsCache) {
        tooltipConfigsCache = new Map([
            [
                ETooltips.Session_Tracking_Start_Date,
                {
                    icon: "alert-outlined",
                    backgroundColor: colorsPalettes.carbon[0],
                    description: "apps.usage.usersengagement.sesstionTrackingStartTime.tooltip",
                    date: dayjs(dateToUTC(swSettings.getDataIndicators("APPS_SESSION_DATA_START"))),
                },
            ],

            [
                ETooltips.Unique_Install_Start_Date,
                {
                    icon: "alert-outlined",
                    backgroundColor: colorsPalettes.carbon[0],
                    description: "apps.usage.storeengagement.uniqueInstall.tooltip",
                    date: dayjs(dateToUTC(uniqueInstallStartTrackingDate)),
                },
            ],
            [
                ETooltips.Store_Policy_Change_Date,
                {
                    icon: "alert-outlined",
                    backgroundColor: colorsPalettes.carbon[0],
                    description: "apps.general.iosPolicyChange.tooltip",
                    date: dayjs(dateToUTC(swSettings.getDataIndicators("IOS_RANKING_POLICY_CHANGE"))),
                },
            ],
            [
                ETooltips.Similar_Algorithm_Change_Date,
                {
                    icon: "alert-outlined",
                    backgroundColor: colorsPalettes.carbon[0],
                    description: "custom.tooltip.defaultText",
                    date: dayjs(dateToUTC(swSettings.getDataIndicators("APPS_ALGO_CHANGE"))),
                },
            ],
            [
                ETooltips.WEEKLY_DATA_AVAILABLE,
                {
                    icon: "alert-outlined",
                    backgroundColor: colorsPalettes.carbon[0],
                    isTooltipLineDisabled: true,
                    isTooltipDisabled: true,
                    description: "apps.overview.ranking.android_rank_missing_january3.tooltip.text",
                    date: dayjs(dateToUTC(swSettings.getDataIndicators("WEEKLY_DATA_AVAILABLE"))),
                },
            ],
        ]);
    }

    return tooltipConfigsCache;
};
